export interface CorrectionEntry {
  id: string;
  date: string;
  title: string;
  was: string;
  now: string;
  why: string;
  where: string;
  status: "published" | "in progress";
  note?: string;
}

export const corrections: CorrectionEntry[] = [
  {
    id: "7",
    date: "2026-10-05",
    title: "Hawaiʻi APCD named as a source",
    was: "Some figures on this site and in Task Force material were described as computed over the Hawaiʻi All-Payer Claims Database.",
    now: "HHIP has never held Hawaiʻi APCD data. The APCD tables were modeled placeholders. Figures computed over them are withdrawn, and the directory funnel's actual sources are the Report 403 roster, NPI de-duplication, the CMS NPI Registry taxonomy check, and plan-filing accepting-new-patients flags.",
    why: "An inspection of HHIP on 5 October 2026 found its APCD tables were modeled placeholders and that no state APCD data had been received.",
    where: "Network Adequacy Theater and The Neighbor Island Surcharge on this site; four Task Force posts.",
    status: "published",
  },
  {
    id: "1",
    date: "2026-08-10",
    title: "Communities without a primary care presence",
    was: "11 communities, 34,916 residents",
    now: "8 communities, 22,014 residents",
    note: "Additional data, October 2026: neither count could be traced to a current source file, so both are withdrawn until the analysis is re-derived.",
    why: "Adding the CMS Medicare Physician file showed that federally qualified health centers and rural health clinics bill as institutional encounters and were invisible in the earlier pull. The count fell by roughly a third; the claim got harder to knock down.",
    where: "Task Force publications, August 2026",
    status: "published",
  },
  {
    id: "2",
    date: "2026-08-15",
    title: "Statewide physician shortage",
    was: "776 FTE (JABSOM 2024)",
    now: "644 FTE direct, 832.6 FTE island-adjusted (JABSOM AHEC 2025)",
    why: "A newer assessment year. The article on this site titled around the 776 figure predates it; the 644 article carries the current figure.",
    where:
      "This site, /articles/776-physician-gap and /articles/644-doctors-short",
    status: "published",
  },
  {
    id: "3",
    date: "2026-08-13",
    title: "Maui stroke baseline and increase",
    was: "28.1 per 100,000 baseline; +82%",
    now: "28.2 per 100,000; +81.2%",
    why: "Transcription error against the Hawaiʻi Health Data Warehouse extract.",
    where: "Stroke briefings, April 2026",
    status: "published",
  },
  {
    id: "4",
    date: "2026-08-13",
    title: "Maui stroke rate described as current",
    was: "51.1 per 100,000 (2021 to 2023)",
    now: "45.7 per 100,000 (2022 to 2024)",
    why: "A newer HHDW release. The 51.1 figure remains correct for its period; it is no longer the current rate.",
    where: "Stroke briefings, April 2026",
    status: "published",
  },
  {
    id: "5",
    date: "2026-08-22",
    title:
      "Oregon described as having a statutory primary care spending floor",
    was: "Rhode Island, Oregon, and Delaware have written a floor into statute",
    now: "Rhode Island (insurance regulation 230-RICR-20-30-4: commercial insurers, 10 percent of medical spending by the end of 2028) and Delaware (18 DE Admin Code 1322: 11.5 percent for plan year 2025) have binding instruments; Oregon requires it by statute for its Medicaid coordinated care organizations; for commercial carriers, a state rule requires a plan to reach it. No statutory penalty",
    why: "Checked against the Oregon Health Authority in August, then read against the enrolled statute on 1 October 2026.",
    where: "Mammography op-ed, Task Force site, August 2026",
    status: "in progress",
  },
  {
    id: "6",
    date: "2026-08-15",
    title: "Insurer directory overstatement headline",
    was: "+180% (physician-only cut)",
    now: "+107% (all primary care clinicians, Cut B) as the lead figure",
    why: "The milder figure survives the APRN and PA scope critique. House rule: never quote a scarier number when the accurate one is milder.",
    where: "Report 403 exhibits and this site",
    status: "published",
  },
];
